import Styles from "./Success.module.css";
import success from "../../../Assets/customer_success.png";
import Header from "../../../SharedComponents/Header/Header";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SupportContactModal from "../../../Modal/SupportContactModal";

export default function Success() {
  const navigate = useNavigate();
  const isproduct = sessionStorage.getItem("isproduct");
  const mobileNumber = sessionStorage.getItem("franchise_mobile");
  const [showSupportListModal, setshowSupportListModal] = useState(false);
  const isActive = sessionStorage.getItem("active_order_success") === "true";

  useEffect(() => {
    sessionStorage.setItem("isproduct", false);
  }, [isproduct]);

  useEffect(() => {
    if (!sessionStorage.getItem("active_order_success")) {
      navigate("/kansas_product/allproducts", { replace: true });
      return;
    }

    window.history.pushState(null, document.title, window.location.href);

    const handlePopState = () => {
      sessionStorage.removeItem("active_order_success");
      navigate("/kansas_product/allproducts", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleContinueShopping = () => {
    sessionStorage.removeItem("active_order_success");
    navigate("/kansas_product/allproducts", { replace: true });
  };

  if (!isActive) {
    return null;
  }

  return (
    <>
      <Header />
      <div className={Styles.overallContainer + " container-fluid p-0"}>
        <div className={Styles.childContainer}>
          <img className={Styles.img} src={success} alt="success" />
          <p className={Styles.success}>Thanks for shopping with us!!!</p>
          <button
            type="button"
            className={Styles.shopMoreBtn}
            onClick={handleContinueShopping}
          >
            Continue Shopping
          </button>
          {mobileNumber && (
            <p className={Styles.note}>
              For more details Call or WhatsApp
              <br />
              <button
                type="button"
                className={Styles.phoneBtn}
                onClick={() => setshowSupportListModal(true)}
              >
                {mobileNumber}
              </button>
            </p>
          )}
        </div>
      </div>
      <SupportContactModal
        show={showSupportListModal}
        onClose={() => setshowSupportListModal(false)}
        phone={mobileNumber}
      />
    </>
  );
}
